import romrBasic from './processing/romr-basic.json';

const processingFlowTemplates = [
    {
        name: 'Overlay',
        description:
            'Overlays a landscape and portrait image over top of the photos taken.',
        definitionJsonString: JSON.stringify(romrBasic),
    },
];

export { processingFlowTemplates };
